export function consoleLog(...args): any
{
    console.log(...args);
}
